import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Zap, Loader2 } from "lucide-react";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(name, email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="flex items-center justify-center p-6 sm:p-12 order-2 lg:order-1">
        <div className="w-full max-w-sm">
          <Link to="/" className="lg:hidden flex items-center gap-2 font-display font-black text-xl mb-8">
            <span className="grid place-items-center w-8 h-8 rounded-md bg-primary text-white"><Zap className="w-5 h-5" /></span> Dirt Or Road
          </Link>
          <h1 className="text-3xl font-black tracking-tight">Become a rider</h1>
          <p className="mt-2 text-muted-foreground">Create your free account in seconds.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label htmlFor="name">Full name</Label>
              <Input id="name" required value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name" className="mt-1.5 bg-secondary/50" placeholder="Alex Rider" />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email" className="mt-1.5 bg-secondary/50" placeholder="you@email.com" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password" className="mt-1.5 bg-secondary/50" placeholder="At least 6 characters" />
            </div>
            {error && <p className="text-sm text-destructive font-medium" data-testid="register-error">{error}</p>}
            <Button type="submit" disabled={loading} data-testid="register-submit" className="w-full h-11 bg-primary hover:bg-[#1D4ED8] text-white font-bold">
              {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Create account"}
            </Button>
          </form>
          <p className="mt-6 text-sm text-muted-foreground">
            Already a rider? <Link to="/login" className="font-bold text-primary hover:underline">Log in</Link>
          </p>
        </div>
      </div>

      <div className="hidden lg:block relative bg-[#0A0A0A] order-1 lg:order-2">
        <img src="https://customer-assets.emergentagent.com/job_quick-bike-share-1/artifacts/5vggut3o_AC549349-6BC2-4460-B3D6-CC17EF330510.PNG" alt="Yamaha NMAX scooter" className="w-full h-full object-cover opacity-80" />
        <div className="absolute inset-0 p-12 flex flex-col justify-between items-end text-right">
          <Link to="/" className="flex items-center gap-2 font-display font-black text-2xl text-white">
            Dirt Or Road <span className="grid place-items-center w-9 h-9 rounded-md bg-primary"><Zap className="w-5 h-5" /></span>
          </Link>
          <p className="text-white text-3xl font-black tracking-tight max-w-sm">Ride more. Earn more. From just £14 a day.</p>
        </div>
      </div>
    </div>
  );
}
